

const AVATAR_COLORS = ['#5D5FEF', '#2969FF', '#E4483D', '#F04438', '#B7791F', '#12B76A', '#7B1FA2', '#0288D1', '#388E3C', '#E64A19']

const getInitials = (name) => {
    const parts = name?.trim().split(/\s+/).filter(Boolean) || []
    if (!parts.length) return '..'
    return (parts.length === 1 ? parts[0].slice(0, 2) : `${parts[0][0]}${parts[parts.length - 1][0]}`).toUpperCase()
}

const getColorForName = (name) => {
    const str = name || '..'
    let hash = 0
    for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash)
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

const GenericAvatarComponent = (props) => {
    const { name, initials, size = 28, className = '', children } = props

    return (
        <div
            className={`rounded-full flex items-center justify-center text-white font-semibold shrink-0 ${className}`}
            style={{ width: size, height: size, minWidth: size, minHeight: size, fontSize: size * 0.4, backgroundColor: getColorForName(name) }}
        >
            {children || initials || getInitials(name)}
        </div>
    )
}

export default GenericAvatarComponent
